<template>
    <button
        v-show="isVisible"
        @click="scrollToTop"
        class="back-to-top d-flex flex-column align-items-center justify-content-center rounded-circle transition"
        :class="{ active: isVisible }"
        aria-label="Back to top"
    >
        <i class="ri-arrow-up-line"></i>
    </button>
</template>

<script>
export default {
    name: 'BackToTop',
    data() {
        return {
            isVisible: false
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        handleScroll() {
            this.isVisible = window.scrollY > 300
        },
        
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }
    }
}
</script>

<style scoped>
.back-to-top {
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 50px;
    height: 50px;
    background: #6698C8;
    color: white;
    border: none;
    cursor: pointer;
    z-index: 999;
    opacity: 0;
    visibility: hidden;
    transform: translateY(20px);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
}

.back-to-top.active {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.back-to-top:hover {
    background: #303E4D;
    transform: translateY(-5px);
}

.back-to-top i {
    font-size: 24px;
}

@media (max-width: 767px) {
    .back-to-top {
        bottom: 20px;
        right: 20px;
        width: 45px;
        height: 45px;
    }
    
    .back-to-top i {
        font-size: 20px;
    }
}
</style>

